import Modal from '../Modal';

/** Sharing a browser is not a toggle: other users' fetches will run in it, logged in as
 *  whoever is logged in there. The server refuses to share without this confirmation. */
export default function ConfirmShareDialog({
  deviceName,
  isOpen,
  onCancel,
  onConfirm,
  busy = false,
}: {
  deviceName: string;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  busy?: boolean;
}) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} title="Share this browser with all users?">
      <div className="space-y-3 text-sm text-gray-600 dark:text-gray-300">
        <p>
          Other users' searches and page fetches will open in{' '}
          <span className="font-medium text-gray-900 dark:text-gray-100">{deviceName}</span>, using
          its cookies, its logged-in sessions and its IP address.
        </p>
        <p>
          Use a Chrome profile that isn't signed in to anything personal - no email, no admin
          consoles, no bank. Users with a browser of their own still use theirs first.
        </p>
      </div>
      <div className="mt-5 flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md text-sm hover:bg-gray-50 dark:hover:bg-gray-700"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={busy}
          className="px-4 py-2 bg-amber-600 text-white rounded-md text-sm hover:bg-amber-700 disabled:opacity-50"
        >
          {busy ? 'Sharing…' : 'Share this browser'}
        </button>
      </div>
    </Modal>
  );
}
